import { useTranslation } from "react-i18next";
import { Languages } from "lucide-react";

const SUPPORTED_LANGUAGES = [
  "en", "es", "fr", "de", "pt", "ja", "ko", "zh",
  "it", "ru", "tr", "pl", "nl", "sv", "da", "fi", "no", "cs",
];

interface LanguageDropdownProps {
  className?: string;
}

const LanguageDropdown = ({ className = "" }: LanguageDropdownProps) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.split("-")[0] || "en";

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <Languages className="w-4 h-4 text-muted-foreground" />
      <select
        aria-label="Language"
        value={current}
        onChange={(e) => i18n.changeLanguage(e.target.value)}
        className="bg-secondary/80 border border-border rounded-lg px-2 py-1.5 text-xs text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50"
      >
        {SUPPORTED_LANGUAGES.map((code) => (
          <option key={code} value={code}>
            {new Intl.DisplayNames([code], { type: "language" }).of(code)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageDropdown;
